module.exports = __webpack_public_path__ + "img/GQD.698ccef0.png";